import { createFeatureSelector } from '@ngrx/store';

export const virtualLocationsState = createFeatureSelector<OLO.State, OLO.State.VirtualLocations>('virtualLocations');
